import React, { useEffect, useState } from "react";
import { useLazyGetRequirementListForSectionBBySGBPApplicationIdQuery, useLazyGetRequirementAdditionalInputFieldForSectionBBySGBPApplicationIdQuery, } from "../../../app/services/SelfEvaluationForm/selfEvalutionServiceApi";
import { useLazyGetProductsListByProductInformationIdQuery } from "../../../app/services/productAndService/productAndServiceApi";
import { useSelfEvaluationSection, buildFieldKey } from "../utils/useSectionEvaluation";
import RequirementCard from "../utils/RequirementCard";
import SimpleAdditionalFieldsBlock from "../utils/SimpleAdditionalFieldsBlock";
import AdditionalFieldInput from "../utils/AdditionalFieldInput";
import NoRecordFound from "../../../components/ui/noRecordFound/NoRecordFound";

const SectionB = () => {
    const [brandList, setBrandList] = useState([]);
    const [getProductsListByProductInformationId, { data: productsData, isLoading: productsLoading },] = useLazyGetProductsListByProductInformationIdQuery();

    const {
        state,
        isLocked,
        sectionRecord,
        fieldList,
        handleFileUpload,
        handleDownload,
        handleDelete,
        handleCaseOfcComment,
        handleFieldChange,
        handleFieldComment,
        handleFieldBlur,
        isFieldInvalid,
        handleApprove,
        handleReject,
        handleClarificationSend,
        approveLoading,
        rejectLoading,
        clarificationLoading,
        approvingReqId,
        rejectingReqId,
        clarifyingReqId,
    } = useSelfEvaluationSection("B", {
        useListQuery: useLazyGetRequirementListForSectionBBySGBPApplicationIdQuery,
        useFieldDefsQuery: useLazyGetRequirementAdditionalInputFieldForSectionBBySGBPApplicationIdQuery,
        onApplicationId: (applicationId) => getProductsListByProductInformationId(applicationId),
    });

    useEffect(() => {
        if (!productsLoading && productsData) {
            const mapped = productsData
                .filter((item) => item.brandName != null)
                .map((item) => ({ id: item.sgbpProductDetailsId, brand: item.brandName, model: item.modelName }));
            setBrandList(mapped);
        }
    }, [productsLoading, productsData]);

    return (
        <div className="section-card">
            <h3 className="section-title">Section 2</h3>
            {sectionRecord.length > 0 ? (
                <>
                    <div className="evaluation-table-wrapper">
                        {sectionRecord.map((item) => {
                            const reqId = item.sgbpRequirementId;
                            const reqData = state?.sections?.B?.requirements?.[reqId] || { files: [], comment: "" };
                            const matchedFields = fieldList.filter((f) => f.sgbpRequirementId === reqId);

                            return (
                                <RequirementCard
                                    key={reqId}
                                    item={item}
                                    reqId={reqId}
                                    isLocked={isLocked}
                                    reqData={reqData}
                                    className="custom-evalution-table"
                                    statusValue={state.sections?.B?.requirements?.[reqId]?.status}
                                    caseOfficerComments={state.sections?.B?.requirements?.[reqId]?.caseOfficerComments}
                                    peerReviewerComments={state.sections?.B?.requirements?.[reqId]?.peerReviewerComments}
                                    onFileUpload={handleFileUpload}
                                    onDownload={handleDownload}
                                    onDelete={handleDelete}
                                    onCaseOfcCommentChange={handleCaseOfcComment}
                                    onClarificationSend={handleClarificationSend}
                                    onReject={handleReject}
                                    onApprove={handleApprove}
                                    clarificationLoading={clarificationLoading && clarifyingReqId === reqId}
                                    rejectLoading={rejectLoading && rejectingReqId === reqId}
                                    approveLoading={approveLoading && approvingReqId === reqId}
                                    isReturnedApplication={state?.sections?.B?.isApplicationReturned}
                                >
                                    {brandList?.length > 0 ? (
                                        matchedFields.map((field) =>
                                            brandList.map((brand) => {
                                                const rawFieldId = field.sgbpAdditionalFieldInputId;
                                                const brandId = brand.id;
                                                const compositeKey = buildFieldKey(rawFieldId, brandId);
                                                const fState = state.sections?.B?.fields?.[compositeKey];

                                                return (
                                                    <React.Fragment key={compositeKey}>
                                                        <div className="left column">
                                                            <label>
                                                                <span style={{ fontSize: "16px", color: "#000000", fontWeight: "500" }}>
                                                                    Brand:{" "}
                                                                </span>
                                                                <span>{brand.brand}</span>
                                                            </label>
                                                            <label className="mt-4">
                                                                <span style={{ fontSize: "16px", color: "#000000", fontWeight: "500" }}>
                                                                    Model:{" "}
                                                                </span>
                                                                <span>{brand.model}</span>
                                                            </label>
                                                        </div>
                                                        <div className="left column">
                                                            <label>
                                                                {field?.label ?? ""}{" "}
                                                                {field?.isRequired && <span className="red-star">*</span>}
                                                            </label>
                                                            <label className="mt-4 instruction-content">
                                                                <div
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: field?.addtionalFieldIntruction || "",
                                                                    }}
                                                                />
                                                            </label>
                                                        </div>
                                                        <div className="right column">
                                                            <AdditionalFieldInput
                                                                field={field}
                                                                value={fState?.value}
                                                                invalid={isFieldInvalid(compositeKey, field.isRequired)}
                                                                isLocked={isLocked}
                                                                onChange={(val) =>
                                                                    handleFieldChange(rawFieldId, val, field.sgbpRequirementId, brandId)
                                                                }
                                                                onBlur={() => handleFieldBlur(compositeKey)}
                                                            />
                                                            <textarea
                                                                disabled
                                                                placeholder=""
                                                                value={fState?.comment || ""}
                                                                onChange={(e) =>
                                                                    handleFieldComment(
                                                                        rawFieldId,
                                                                        e.target.value,
                                                                        field.sgbpRequirementId,
                                                                        brandId
                                                                    )
                                                                }
                                                                style={isLocked ? { background: "#f5f5f5", cursor: "not-allowed" } : {}}
                                                            />
                                                        </div>
                                                    </React.Fragment>
                                                );
                                            })
                                        )
                                    ) : (
                                        <SimpleAdditionalFieldsBlock
                                            matchedFields={matchedFields}
                                            sectionFields={state.sections?.B?.fields}
                                            isLocked={isLocked}
                                            isFieldInvalid={isFieldInvalid}
                                            onFieldChange={handleFieldChange}
                                            onFieldComment={handleFieldComment}
                                            onFieldBlur={handleFieldBlur}
                                        />
                                    )}
                                </RequirementCard>
                            );
                        })}
                    </div>
                    <div className="sectionC-info">
                        <div className="rating-box">
                            {/* <h4>Rating</h4> */}
                            <div className="sectionC-header">
                                <h3 className="sectionC-title" >Section 2 Minimum Criteria: <input
                                    type="text"
                                    className="rating-input"
                                    value={state?.sectionBMinCriteria}
                                    disabled
                                // onChange={(e) => onServiceMinCriteriaChange(e.target.value)}
                                />
                                    <span className="rating-total">/{sectionRecord?.length || "N.A"}</span></h3>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <NoRecordFound />
            )}
        </div>
    );
};

export default SectionB;